window.addEventListener('DOMContentLoaded', function () {
  /**
   * @type {MapRenderer}
   */
  let map = null;

  jQuery(function ($) {
    const valid_filters = {
      city: $(`[data-filter-name="city"]`)
        .get()
        .map((elem) => $(elem).data('filterValue')?.toLowerCase() || '')
        .filter(Boolean),
      sport: $(`[data-filter-name="sport"]`)
        .get()
        .map((elem) => $(elem).data('filterValue')?.toLowerCase() || '')
        .filter(Boolean),
      week: $(`[data-filter-name="week"] option`)
        .get()
        .map((elem) => $(elem).val()?.toLowerCase() || '')
        .filter(Boolean),
    };

    let appliedFilters = {};

    function updateFiltersFromElement(elem) {
      let filterName = $(elem).data('filterName');
      let filterValue = $(elem).data('filterValue');

      if (
        typeof filterName == 'undefined' ||
        typeof filterValue == 'undefined'
      ) {
        console.warn('Missing filter name or value on', elem);
      }

      let newFilter = {
        [filterName]: filterValue === -1 ? 'remove' : filterValue,
      };

      updateFilters(newFilter);
    }

    function updateHistory() {
      let url = new URL(window.location);
      url.searchParams.delete('city');
      url.searchParams.delete('sport');

      Object.keys(appliedFilters).forEach((filterName) => {
        let filterValue = appliedFilters[filterName];
        if (typeof filterValue == 'undefined') return;
        url.searchParams.set(filterName, filterValue);
      });

      history.pushState({}, '', url);
    }

    /**
     *
     * @param {{[key: string]: string}} filters
     */
    function updateFilters(filters) {
      if (!Object.keys(filters).length) {
        console.warn('No filters applied');
        return;
      }

      let validatedFilters = Object.keys(filters).reduce(function (
        validatedFilters,
        filterName,
      ) {
        let filterValue = filters[filterName];
        if (typeof filterValue == 'undefined') return validatedFilters;
        filterValue = filterValue.toString().toLowerCase();

        if (filterValue === 'remove') {
          delete appliedFilters[filterName];
          return validatedFilters;
        }

        if (!valid_filters[filterName].includes(filterValue)) {
          console.warn('Invalid filter value', filterName, filterValue);
          return validatedFilters;
        }

        validatedFilters[filterName] = filterValue;
        return validatedFilters;
      }, {});

      if (!Object.keys(validatedFilters).length) {
        console.warn('No valid filters applied');
        return;
      }

      appliedFilters = { ...appliedFilters, ...validatedFilters };

      Object.keys(appliedFilters).forEach(function (filterName) {
        let filterValue = appliedFilters[filterName];

        let filterElem = $(`[data-filter-name="${filterName}"]`)
          .get()
          .filter(
            (filterElem) =>
              filterElem.dataset.filterValue.toLowerCase() ==
              filterValue.toLowerCase(),
          );

        if (!filterElem) {
          console.warn('No filter element found for', filterName, filterValue);
          return;
        }

        let $filterElem = $(filterElem);

        $filterElem.siblings().removeClass('active');

        if ($filterElem.is('[data-dropdown-item]')) {
          let dropdownWrapper = $filterElem.closest('[data-dropdown]');
          dropdownWrapper
            .find('[data-dropdown-label]')
            .text($filterElem.text().trim());

          dropdownWrapper.find('[data-dropdown-value]').val(filterValue);
        }

        $filterElem.addClass('active');
      });
      updateHistory();

      map.setFilters(appliedFilters);
    }

    /**
     *
     * @param {string} cityName The city name to focus on
     * @returns {[boolean, {lat: number, lng: number}?]}
     */
    function getCityCenter(cityName) {
      let retVal = [false, null];

      if (!cityName) return retVal;

      let cityDef = window.theme.cities.find(
        (city) => city.city_name.toLowerCase() == cityName.toLowerCase(),
      );

      if (!cityDef) {
        console.warn('No city definition found for', appliedFilters.city);
        return retVal;
      }

      retVal[0] = true;
      retVal[1] = {
        lat: parseFloat(cityDef.latitude),
        lng: parseFloat(cityDef.longitude),
      };

      return retVal;
    }

    function extractMarkerDetails(elem) {
      try {
        let $camp = $(elem);

        let variantId = $camp.data('variantId');

        if (!variantId) {
          console.warn('No variant id found on', elem);
          return;
        }

        let campVariant = window.theme.allCamps.find(
          (camp) => camp.id == variantId,
        );

        if (!campVariant) {
          console.warn('No camp product found for', variantId);
          return;
        }

        if (!campVariant.location_details) {
          console.warn('No location details found for', variantId);
          return;
        }

        return {
          lat: parseFloat(campVariant.location_details.latitude),
          lng: parseFloat(campVariant.location_details.longitude),
          title: campVariant?.location_details?.location_name ?? '',
          camp: campVariant,
        };
      } catch (e) {
        console.error(e);
        return null;
      }
    }

    function filterLocations() {
      let matchedCount = 0;

      let campCardsWrapper = $('.camps-list');

      if (!campCardsWrapper.length) {
        console.warn('No camp cards wrapper found');
        return;
      }

      campCardsWrapper.removeClass('hidden');

      let campCards = campCardsWrapper.find('.camp-card__wrapper');

      if (!campCards.length) {
        console.warn('No camp cards found');
        return;
      }

      campCardsWrapper.toggleClass(
        'filtered',
        Object.keys(appliedFilters).length > 0,
      );
      campCards.toggleClass('matched-filter', true);
      $('.initial-message').toggleClass('hidden', true);

      if (!Object.keys(appliedFilters).length) {
        console.warn('No filters applied');
        return;
      }

      campCards.each(function () {
        let $card = $(this);

        let cardData = {
          week: $card.data('week'),
          city: $card.data('city'),
          sport: $card.data('sport'),
        };
        let matched = true;

        for (let filterName in appliedFilters) {
          let filterValue = appliedFilters[filterName].toString();

          if (typeof filterValue == 'undefined') continue;

          if (
            cardData[filterName]?.toString()?.toLowerCase() !=
            filterValue.toLowerCase()
          ) {
            matched = false;
            break;
          }
        }

        $card.toggleClass('matched-filter', matched);

        if (matched) {
          matchedCount++;
        }
      });

      campCardsWrapper.toggleClass('hidden', matchedCount === 0);
      $('.no-camps-message').toggleClass('hidden', matchedCount !== 0);
    }

    $('[data-camp-finder-filter]:not(select)').on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      updateFiltersFromElement(this);

      $(this).siblings().removeClass('active');
      $(this).toggleClass('active', true);

      let selectedCampCard = $('.selected-camp-card');
      selectedCampCard.toggleClass('hidden', true);

      filterLocations();
    });
    $('.week-filter').on('change', function (e) {
      let $this = $(this);

      $this.attr('data-filter-value', $this.val());
      $this.data('filterValue', +$this.val());

      updateFiltersFromElement(this);

      filterLocations();
    });

    $('.toggle-map').on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      $('.map-wrapper').toggleClass('active');
    });

    $('.camp-card__hitpoint').on('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      $('.camp-card__wrapper').removeClass('selected');

      let wrapper = $(this).find('.camp-card__wrapper').get(0);

      if (!wrapper) return;

      $(wrapper).addClass('selected');

      let marker = extractMarkerDetails(wrapper);

      console.debug(marker);

      map.getMap().flyTo({
        center: { lat: marker.lat, lng: marker.lng },
        zoom: map.config.maxZoom,
      });

      updateSelectedCampCard(marker.camp);

      $('.map-wrapper').toggleClass('active');
    });

    $(window).on('popstate', function (e) {
      handleQueryFilters();
    });

    function handleQueryFilters() {
      return new Promise(function (resolve, reject) {
        try {
          let queryString = new URLSearchParams(window.location.search);

          let city = queryString.get('city');
          let sport = queryString.get('sport');

          let initialFilter = {};

          if (city) initialFilter.city = city;

          if (sport) initialFilter.sport = sport;
          updateFilters(initialFilter);

          filterLocations();
          resolve();
        } catch (e) {
          reject(e);
        }
      });
    }

    function updateSelectedCampCard(camp) {
      try {
        let selectedCampCard = $('.selected-camp-card');

        if (!selectedCampCard.length) {
          console.warn('No selected camp card found');
          return;
        }

        selectedCampCard.toggleClass('hidden', false);

        selectedCampCard.data('camp', camp);

        let product = window.theme.campProducts.find(
          (product) => product.id == camp.product_id,
        );

        if (!product) {
          throw 'No product found for camp';
        }

        selectedCampCard.data('product', product);

        let imgSrc = camp.featured_image?.url ?? product.featured_image;

        selectedCampCard.find('.selected-camp-card-image').attr('src', imgSrc);

        let campTitle = product.title;

        if (product.title.toLowerCase().indexOf('community sports') > -1) {
          campTitle = window.theme.strings.community_title_template.replace(
            '{{ sport_name }}',
            camp.sport_name,
          );
        }

        selectedCampCard.find('.camp-title').text(campTitle);

        selectedCampCard.find('.camp-dates').text(camp.camp_dates);

        selectedCampCard
          .find('.camp-location')
          .text(camp.location_details.location_name);

        if (camp.compare_at_price && camp.compare_at_price !== camp.price) {
          selectedCampCard.find('.sale-price').text(`$${camp.price / 100}`);
          selectedCampCard
            .find('.full-price')
            .text(`$${camp.compare_at_price / 100}`);
        } else {
          selectedCampCard.find('.sale-price').text(`$${camp.price / 100}`);
        }

        selectedCampCard
          .closest('.selected-card-hitpoint')
          .attr('href', camp.url);
      } catch (e) {
        console.error(e);
      }
    }

    async function initMap() {
      // Render Map
      let mapWrapper = document.querySelector('.map-wrapper');

      if (!mapWrapper) return;

      // Don't re-initialize the map if it's already initialized
      if (map) map.getMap().remove();

      map = new MapRenderer({
        container: mapWrapper,
        geojson: window.theme.campGeojsonData,
        mapId: 'get-started',
        features: {
          popups: false,
        },
      });

      mapWrapper.addEventListener('map:pin-click', function (e) {
        console.debug('map:pin-click');
        console.log(e.detail);

        const campCards = document.querySelectorAll('.camp-card__wrapper');

        if (!campCards.length) return;

        const matchingCampCard = Array.from(campCards).find((card) => {
          return (
            card.dataset.variantId.toString() ===
            e.detail.properties.id.toString()
          );
        });

        if (!matchingCampCard) return;

        matchingCampCard.classList.add('selected');

        matchingCampCard.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });

        const markerDetails = extractMarkerDetails(matchingCampCard);

        if (!markerDetails) return;

        updateSelectedCampCard(markerDetails.camp);
      });

      mapWrapper.addEventListener('map:markers-empty', function (e) {
        console.debug('map:markers-empty');
        let currentCity = appliedFilters.city;

        if (!currentCity) return;

        let [centerFound, center] = getCityCenter(currentCity);

        if (centerFound) map.getMap().easeTo({ center, zoom: 11 });
      });
    }

    function postInit() {
      map.getMap().on('load', () => {
        handleQueryFilters();
      });
    }

    initMap().then(postInit);
  });
});
